export enum CategoryType {
  searchProfileMatched = 'Search Profile Matched',
  searchProfileNotMatched = 'Search Profile NotMatched',
  searchProfileContinue = 'Search Profile Continue Button',
  inviteThemButton = 'Invite Them Button',
  sendInvitationButton = 'Send Invitation Button',
  sendGoalcardButton = 'Send Goalcard Button',
  customizeGoalcardDesign = 'Customize Goalcard Design',
  customizeGoalcardContinue = 'Customize Goalcard Continue Button',
  submitPaymentButton = 'Submit Payment Button',
  sendAnotherGoalcardButton = 'Send Another Goalcard Button',
  downloadButton = 'Download Button',
}

export enum ActionType {
  Goalcard_SearchProfile_ProfileMatched = 'Goalcard_SearchProfile_ProfileMatched',
  Goalcard_SearchProfile_ProfileNotMatched = 'Goalcard_SearchProfile_ProfileNotMatched',
  Goalcard_SearchProfile_ContinueButton = 'Goalcard_SearchProfile_ContinueButton',
  Goalcard_SendInvitation_InviteThemButton = 'Goalcard_SendInvitation_InviteThemButton',
  Goalcard_SendInvitation_SendInvitationButton = 'Goalcard_SendInvitation_SendInvitationButton',
  Goalcard_SendInvitation_SendGoalcardButton = 'Goalcard_SendInvitation_SendGoalcardButton',
  Goalcard_CustomizeGoalcard_GoalcardDesign = 'Goalcard_CustomizeGoalcard_GoalcardDesign',
  Goalcard_CustomizeGoalcard_ContinueButton = 'Goalcard_CustomizeGoalcard_ContinueButton',
  Goalcard_GoalcardPayment_SubmitPaymentButton = 'Goalcard_GoalcardPayment_SubmitPaymentButton',
  Goalcard_FinalScreen_SendAnotherGoalcardButton = 'Goalcard_FinalScreen_SendAnotherGoalcardButton',
  Goalcard_FinalScreen_DownloadButton = 'Goalcard_FinalScreen_DownloadButton',
}
